import isEmpty from 'lodash/isEmpty';
import {
  getIntrabankDetail,
  getRtgsDetail,
  getSknDetail,
  getVirtualAccountDetail,
  getEWalletDetail,
  getInterbankDetail,
  getIntrabankDetailFromTransfer,
  getVirtualAccountDetailAfterTransfer,
  getSknDetailAfterTransfer,
  getRtgsDetailAfterTransfer,
  getEWalletDetailAfterTransfer,
  getInterbankDetailAfterTransfer,
  getInterbankConfirmation,
  getIntrabankConfirmation,
  getEWalletConfirmation,
  getVirtualAccountConfirmation,
  getRtgsConfirmation,
  getSknConfirmation,
  requestIntrabankTac,
  getIntrabankResult,
  getSknTac,
  requestRtgsTac,
  requestVirtualAccountTac,
  requestEWalletTac,
  requestInterbankTac,
  getVirtualAccountResult,
  getEWalletResult,
  getInterbankResult,
  getSknResult,
  getRtgsResult,
  deleteIntrabankFavourite,
  getSwiftConfirmation,
  getSwiftResult,
  requestSwiftTAC,
  getSwiftDetailAfterTransfer,
  deleteInterbankFavourite,
  getDeleteIntrabankResult,
  getDeleteInterbankResult,
  requestDeleteIntrabankTac,
  requestDeleteInterbankTac,
  requestDeleteSknTac,
  getDeleteSknResult,
  deleteSknFavourite,
  deleteRtgsFavourite,
  getDeleteRtgsResult,
  requestDeleteRtgsTac,
  requestDeleteVirtualAccountTac,
  getDeleteVirtualAccountResult,
  deleteVirtualAccountFavourite,
  deleteEWalletFavourite,
  getDeleteEWalletResult,
  requestDeleteEWalletTac,
  deleteSwiftFavourite,
  getDeleteSwiftResult,
  requestDeleteSwiftTac,
  getIntrabankEditDetail,
  getIntrabankEditConfirmation,
  getIntrabankEditRequestTac,
  getIntrabakEditResult,
  getInterbankEditDetail,
  getInterbankEditConfirmation,
  requestInterbankEditTac,
  getInterbankEditResult,
  getEWalletEditDetail,
  getEWalletEditConfirmation,
  requestEWalletEditTac,
  getEWalletEditResult,
  getVirtualAccountEditDetail,
  getVirtualAccountEditConfirmation,
  requestVirtualAccountEditTac,
  getVirtualAccountEditResult,
  getRtgsEditDetail,
  getRtgsEditConfirmation,
  requestRtgsEditTac,
  getSknEditTac,
  getRtgsEditResult,
  getSknEditResult,
  getSknEditConfirmation,
  getSknEditDetail,
  getSwiftEditDetail,
  getSwiftEditConfirmation,
  requestSwiftEditTAC,
  getSwiftEditResult,
  putResetTransferFavTac,
} from 'middleware/actions/favourite/transfer';
import {
  getIntrabankDeleteFavouriteResultPayload,
  getIntrabankEditFavouriteResultPayload,
  getIntrabankFavouriteBeneficiaryDetails,
  getIntrabankFavouriteDynamicFields,
  getIntrabankFavouriteTransferDetail,
} from 'utils/transfer/intrabank/getter';
import {
  getSknRtgsDeleteFavouriteResultPayload,
  getSknRtgsEditFavouriteResultPayload,
  getSknRtgsFavouriteBeneficiaryDetails,
  getSknRtgsFavouriteDynamicFields,
  getSknRtgsFavouriteTransferDetail,
} from 'utils/transfer/sknRtgs/getter';
import {
  getEWalletCommonFavouriteResultPayload,
  getEWalletFavouriteBeneficiaryDetails,
  getEWalletFavouriteDynamicFields,
  getEWalletFavouriteTransferDetail,
} from 'utils/transfer/e-wallet/getter';
import {
  getInterbankDeleteFavouriteResultPayload,
  getInterbankEditFavouriteResultPayload,
  getInterbankFavouriteBeneficiaryDetails,
  getInterbankFavouriteDynamicFields,
  getInterbankFavouriteTransferDetail,
} from 'utils/transfer/interbank/getter';
import {
  getVirtualAccountDeleteFavouriteResultPayload,
  getVirtualAccountEditFavouriteResultPayload,
  getVirtualAccountFavouriteBeneficiaryDetails,
  getVirtualAccountFavouriteDetail,
  getVirtualAccountFavouriteDynamicFields,
} from 'utils/transfer/virtual-account/getter';
import { get } from 'utils/lodash';
import { store } from 'providers/store';
import { formatCommonFavouriteResultPayload } from 'utils/transfer/formatter';
import { formatIntrabankEditDetailPayload, formatIntrabankEditFavouriteConfirm } from 'utils/transfer/intrabank/formatter';
import {
  getSwiftCommonFavouriteResultPayload,
  getSwiftFavouriteBeneficiaryDetails,
  getSwiftFavouriteTransferDetail,
} from 'utils/transfer/swift/getter';
import {
  formatSwiftEditDetailPayload,
  formatSwiftEditFavouriteConfirm,
  formatSwiftFavouriteConfirmPayload,
  formatSwiftFavouriteResultPayload,
} from 'utils/transfer/swift/formatter';

import {
  SKN_TRANSFER,
  RTGS_TRANSFER,
  SWIFT_TRANSFER,
  E_WALLET,
  INTRABANK,
  INTERBANK,
  VIRTUAL_ACCOUNT,
} from 'settings/constants/transaction';
import { FAVOURITE_TRANSFER_TYPES } from 'settings/constants/transfer/favourite/form';
import { FAVOURITE_ADD_NEW, FAVOURITE_EDIT, FAVOURITE_SELECTION } from 'settings/constants/common';
import { SWIFT_EDIT_FAVOURITE, SWIFT_NEW_FAVOURITE } from 'settings/constants/transfer/swift/form';
import { SKN_RTGS_EDIT_FAVOURITE, SKN_RTGS_NEW_FAVOURITE } from 'settings/constants/transfer/skn/form';
import { E_WALLET_EDIT_FAVOURITE, E_WALLET_NEW_FAVOURITE } from 'settings/constants/transfer/e-wallet/form';
import { INTRABANK_EDIT_FAVOURITE, INTRABANK_NEW_FAVOURITE } from 'settings/constants/transfer/intrabank/form';
import { INTERBANK_EDIT_FAVOURITE, INTERBANK_NEW_FAVOURITE } from 'settings/constants/transfer/interbank/form';
import { VIRTUAL_ACCOUNT_EDIT_FAVOURITE, VIRTUAL_ACCOUNT_NEW_FAVOURITE } from 'settings/constants/transfer/virtual-account/form';
import {
  formatInterbankAddFavouriteResultPayload,
  formatInterbankEditDetailPayload,
  formatInterbankEditFavouriteConfirm,
} from 'utils/transfer/interbank/formatter';
import {
  formatEWalletAddFavouriteResultPayload,
  formatEWalletEditDetailPayload,
  formatEWalletEditFavouriteConfirm,
} from 'utils/transfer/e-wallet/formatter';
import { formatVirtualAccountEditFavouriteConfirm } from 'utils/transfer/virtual-account/formatter';
import { formatSknRtgsEditFavouriteConfirm } from 'utils/transfer/sknRtgs/formatter';
import {
  getEWalletNewFavPayload,
  getInterbankNewFavPayload,
  getIntrabankNewFavPayload,
  getRtgsNewFavPayload,
  getSknNewFavPayload,
  getVirtualAccountNewFavPaylaod,
} from './getter';

export const submitActionHandler = (isDetailSuccess, isSwiftTransfer, isEditFavouriteDetailSuccess) => {
  if (isSwiftTransfer) {
    return SWIFT_TRANSFER;
  }

  if (isDetailSuccess && !isEditFavouriteDetailSuccess) {
    return FAVOURITE_ADD_NEW;
  }

  if (isEditFavouriteDetailSuccess) {
    return FAVOURITE_EDIT;
  }

  return FAVOURITE_SELECTION;
};

export const formTitleHandler = (isDetailSuccess, type, isSwiftBankSearch) => {
  const handler = {
    [SKN_TRANSFER]: 'transaction.favourite.form.title.skn',
    [RTGS_TRANSFER]: 'transaction.favourite.form.title.rtgs',
    [SWIFT_TRANSFER]: 'transaction.favourite.form.title.swift',
    [E_WALLET]: 'transaction.favourite.form.title.eWallet',
    [INTRABANK]: 'transaction.favourite.form.title.intrabank',
    [INTERBANK]: 'transaction.favourite.form.title.interbank',
    [VIRTUAL_ACCOUNT]: 'transaction.favourite.form.title.virtualAccount',
    default: 'transaction.favourite.form.title.addNew',
  };
  return ((isDetailSuccess || isSwiftBankSearch) && handler[type]) || handler.default;
};

export const favouriteFormDetailHandler = (type, userId, onChange) => {
  const handler = {
    [SKN_TRANSFER]: () => store.dispatch(getSknDetail({ userId })),
    [RTGS_TRANSFER]: () => store.dispatch(getRtgsDetail({ userId })),
    [SWIFT_TRANSFER]: () => {
      // swift will directly open bank search
      onChange({ isSwiftBankSearch: true });
    },
    [E_WALLET]: () => store.dispatch(getEWalletDetail({ userId })),
    [INTRABANK]: () => store.dispatch(getIntrabankDetail({ userId })),
    [INTERBANK]: () => store.dispatch(getInterbankDetail({ userId })),
    [VIRTUAL_ACCOUNT]: () => store.dispatch(getVirtualAccountDetail({ userId })),
    default: () => {},
  };
  return (handler[type] || handler.default)();
};

export const favouriteFormAfterTransferDetailHandler = (type, userId, addFavObject) => {
  const handler = {
    [SKN_TRANSFER]: () => store.dispatch(getSknDetailAfterTransfer({ userId, addFavObject })),
    [RTGS_TRANSFER]: () => store.dispatch(getRtgsDetailAfterTransfer({ userId, addFavObject })),
    [SWIFT_TRANSFER]: () => store.dispatch(getSwiftDetailAfterTransfer({ userId, addFavObject })),
    [E_WALLET]: () => store.dispatch(getEWalletDetailAfterTransfer({ userId, addFavObject })),
    [INTRABANK]: () => store.dispatch(getIntrabankDetailFromTransfer({ userId, addFavObject })),
    [INTERBANK]: () => store.dispatch(getInterbankDetailAfterTransfer({ userId, addFavObject })),
    [VIRTUAL_ACCOUNT]: () => store.dispatch(getVirtualAccountDetailAfterTransfer({ userId, addFavObject })),
    default: () => {},
  };
  return (handler[type] || handler.default)();
};

export const addNewFavPayload = (type, state) => {
  const handler = {
    [SKN_TRANSFER]: () => getSknNewFavPayload(state),
    [E_WALLET]: () => getEWalletNewFavPayload(state),
    [RTGS_TRANSFER]: () => getRtgsNewFavPayload(state),
    [INTRABANK]: () => getIntrabankNewFavPayload(state),
    [INTERBANK]: () => getInterbankNewFavPayload(state),
    [VIRTUAL_ACCOUNT]: () => getVirtualAccountNewFavPaylaod(state),
    default: () => {},
  };
  return (handler[type] || handler.default)();
};

export const addNewFavouriteDispatchHandler = (type, state) => {
  const payload = addNewFavPayload(type, state);
  const handler = {
    [SKN_TRANSFER]: () => store.dispatch(getSknConfirmation(payload)),
    [RTGS_TRANSFER]: () => store.dispatch(getRtgsConfirmation(payload)),
    [SWIFT_TRANSFER]: () => store.dispatch(getSwiftConfirmation(formatSwiftFavouriteConfirmPayload(state))),
    [E_WALLET]: () => store.dispatch(getEWalletConfirmation(payload)),
    [INTRABANK]: () => store.dispatch(getIntrabankConfirmation(payload)),
    [INTERBANK]: () => store.dispatch(getInterbankConfirmation(payload)),
    [VIRTUAL_ACCOUNT]: () => store.dispatch(getVirtualAccountConfirmation(payload)),
    default: () => {},
  };
  return (handler[type] || handler.default)();
};

export const editFavouriteSelectionHandler = payload => {
  const transferType = get(payload, 'transferType', '');

  const handler = {
    [SKN_TRANSFER]: () => store.dispatch(getSknEditDetail(formatInterbankEditDetailPayload(payload))),
    [RTGS_TRANSFER]: () => store.dispatch(getRtgsEditDetail(formatInterbankEditDetailPayload(payload))),
    [VIRTUAL_ACCOUNT]: () => store.dispatch(getVirtualAccountEditDetail(formatIntrabankEditDetailPayload(payload))),
    [E_WALLET]: () => store.dispatch(getEWalletEditDetail(formatEWalletEditDetailPayload(payload))),
    [INTRABANK]: () => store.dispatch(getIntrabankEditDetail(formatIntrabankEditDetailPayload(payload))),
    [INTERBANK]: () => store.dispatch(getInterbankEditDetail(formatInterbankEditDetailPayload(payload))),
    [SWIFT_TRANSFER]: () => store.dispatch(getSwiftEditDetail(formatSwiftEditDetailPayload(payload))),
    default: () => {},
  };
  return (handler[transferType] || handler.default)();
};

export const editFavouriteSubmitFormHandler = (type, payload) => {
  const handler = {
    [SKN_TRANSFER]: () => store.dispatch(getSknEditConfirmation(formatSknRtgsEditFavouriteConfirm(payload))),
    [RTGS_TRANSFER]: () => store.dispatch(getRtgsEditConfirmation(formatSknRtgsEditFavouriteConfirm(payload))),
    [VIRTUAL_ACCOUNT]: () => store.dispatch(getVirtualAccountEditConfirmation(formatVirtualAccountEditFavouriteConfirm(payload))),
    [E_WALLET]: () => store.dispatch(getEWalletEditConfirmation(formatEWalletEditFavouriteConfirm(payload))),
    [INTRABANK]: () => store.dispatch(getIntrabankEditConfirmation(formatIntrabankEditFavouriteConfirm(payload))),
    [INTERBANK]: () => store.dispatch(getInterbankEditConfirmation(formatInterbankEditFavouriteConfirm(payload))),
    [SWIFT_TRANSFER]: () => store.dispatch(getSwiftEditConfirmation(formatSwiftEditFavouriteConfirm(payload))),
    default: () => {},
  };
  return (handler[type] || handler.default)();
};

export const editFavouriteRequestTacHandler = (type, payload) => {
  store.dispatch(putResetTransferFavTac());
  const handler = {
    [SKN_TRANSFER]: () => store.dispatch(getSknEditTac(payload)),
    [RTGS_TRANSFER]: () => store.dispatch(requestRtgsEditTac(payload)),
    [VIRTUAL_ACCOUNT]: () => store.dispatch(requestVirtualAccountEditTac(payload)),
    [E_WALLET]: () => store.dispatch(requestEWalletEditTac(payload)),
    [INTRABANK]: () => store.dispatch(getIntrabankEditRequestTac(payload)),
    [INTERBANK]: () => store.dispatch(requestInterbankEditTac(payload)),
    [SWIFT_TRANSFER]: () => store.dispatch(requestSwiftEditTAC(payload)),
    default: () => {},
  };
  return (handler[type] || handler.default)();
};

export const editFavouriteResultHandler = (type, payload) => {
  const handler = {
    [SKN_TRANSFER]: () => store.dispatch(getSknEditResult(getSknRtgsEditFavouriteResultPayload(payload))),
    [RTGS_TRANSFER]: () => store.dispatch(getRtgsEditResult(getSknRtgsEditFavouriteResultPayload(payload))),
    [VIRTUAL_ACCOUNT]: () => store.dispatch(getVirtualAccountEditResult(getVirtualAccountEditFavouriteResultPayload(payload))),
    [E_WALLET]: () => store.dispatch(getEWalletEditResult(getEWalletCommonFavouriteResultPayload(payload))),
    [INTRABANK]: () => store.dispatch(getIntrabakEditResult(getIntrabankEditFavouriteResultPayload(payload))),
    [INTERBANK]: () => store.dispatch(getInterbankEditResult(getInterbankEditFavouriteResultPayload(payload))),
    [SWIFT_TRANSFER]: () => store.dispatch(getSwiftEditResult(getSwiftCommonFavouriteResultPayload(payload))),
    default: () => {},
  };
  return (handler[type] || handler.default)();
};

export const addNewFormFieldHandler = (isDetailSuccess, type, transferTypes) => {
  const handler = {
    [SKN_TRANSFER]: () => SKN_RTGS_NEW_FAVOURITE,
    [RTGS_TRANSFER]: () => SKN_RTGS_NEW_FAVOURITE,
    [SWIFT_TRANSFER]: () => SWIFT_NEW_FAVOURITE,
    [E_WALLET]: () => E_WALLET_NEW_FAVOURITE,
    [INTRABANK]: () => INTRABANK_NEW_FAVOURITE,
    [INTERBANK]: () => INTERBANK_NEW_FAVOURITE,
    [VIRTUAL_ACCOUNT]: () => VIRTUAL_ACCOUNT_NEW_FAVOURITE,
    default: () => (!isEmpty(transferTypes) && FAVOURITE_TRANSFER_TYPES(transferTypes)) || [],
  };

  return ((isDetailSuccess && handler[type]) || handler.default)();
};

export const editFormFieldHandler = (isDetailSuccess, type) => {
  const handler = {
    [SKN_TRANSFER]: SKN_RTGS_EDIT_FAVOURITE,
    [RTGS_TRANSFER]: SKN_RTGS_EDIT_FAVOURITE,
    [SWIFT_TRANSFER]: SWIFT_EDIT_FAVOURITE,
    [E_WALLET]: E_WALLET_EDIT_FAVOURITE,
    [INTRABANK]: INTRABANK_EDIT_FAVOURITE,
    [INTERBANK]: INTERBANK_EDIT_FAVOURITE,
    [VIRTUAL_ACCOUNT]: VIRTUAL_ACCOUNT_EDIT_FAVOURITE,
    default: [],
  };

  return (isDetailSuccess && handler[type]) || handler.default;
};

export const addNewDynamicFieldHandler = (type, addNewDetail, isFromTransferResult) => {
  const handler = {
    [SKN_TRANSFER]: getSknRtgsFavouriteDynamicFields(addNewDetail, isFromTransferResult),
    [RTGS_TRANSFER]: getSknRtgsFavouriteDynamicFields(addNewDetail, isFromTransferResult),
    [E_WALLET]: getEWalletFavouriteDynamicFields(addNewDetail, isFromTransferResult),
    [INTRABANK]: getIntrabankFavouriteDynamicFields(addNewDetail, isFromTransferResult),
    [INTERBANK]: getInterbankFavouriteDynamicFields(addNewDetail),
    [VIRTUAL_ACCOUNT]: isFromTransferResult && getVirtualAccountFavouriteDynamicFields(addNewDetail),
    [SWIFT_TRANSFER]: [],
    default: [],
  };

  return handler[type] || handler.default;
};

// TODO: Retrieve detail isSuccess status
export const favouriteDetailHandler = (
  type,
  {
    intrabankFormDetail,
    virtualAccountFavouriteDetail,
    sknFavouriteDetail,
    rtgsFavouriteDetail,
    eWalletFavouriteDetail,
    interbankFavouriteDetail,
    swiftFavouriteDetail,
  }
) => {
  const handler = {
    [SKN_TRANSFER]: sknFavouriteDetail,
    [RTGS_TRANSFER]: rtgsFavouriteDetail,
    [SWIFT_TRANSFER]: swiftFavouriteDetail,
    [E_WALLET]: eWalletFavouriteDetail,
    [INTERBANK]: interbankFavouriteDetail,
    [INTRABANK]: intrabankFormDetail,
    [VIRTUAL_ACCOUNT]: virtualAccountFavouriteDetail,
    default: {},
  };
  return handler[type] || handler.default;
};

export const addNewFavouriteFromTransferDetail = (type, addNewDetail, isEditFavourite, formDetail) => {
  const handler = {
    [SKN_TRANSFER]: () => getSknRtgsFavouriteTransferDetail(addNewDetail, isEditFavourite, formDetail),
    [RTGS_TRANSFER]: () => getSknRtgsFavouriteTransferDetail(addNewDetail, isEditFavourite, formDetail),
    [SWIFT_TRANSFER]: () => getSwiftFavouriteTransferDetail(addNewDetail, isEditFavourite, formDetail),
    [E_WALLET]: () => getEWalletFavouriteTransferDetail(addNewDetail, isEditFavourite),
    [INTRABANK]: () => getIntrabankFavouriteTransferDetail(addNewDetail, isEditFavourite),
    [INTERBANK]: () => getInterbankFavouriteTransferDetail(addNewDetail, isEditFavourite, formDetail),
    [VIRTUAL_ACCOUNT]: () => getVirtualAccountFavouriteDetail(addNewDetail, isEditFavourite),
    default: () => {},
  };
  return (handler[type] || handler.default)();
};

export const favouriteTacDetailHandler = (
  type,
  {
    intrabankFavouriteTac,
    virtualAccountFavouriteTac,
    eWalletFavouriteTac,
    rtgsFavouriteTac,
    sknFavouriteTac,
    interbankFavouriteTac,
    swiftFavouriteTac,
  }
) => {
  const handler = {
    [SKN_TRANSFER]: sknFavouriteTac,
    [RTGS_TRANSFER]: rtgsFavouriteTac,
    [SWIFT_TRANSFER]: swiftFavouriteTac,
    [E_WALLET]: eWalletFavouriteTac,
    [INTERBANK]: interbankFavouriteTac,
    [INTRABANK]: intrabankFavouriteTac,
    [VIRTUAL_ACCOUNT]: virtualAccountFavouriteTac,
    default: {},
  };
  return handler[type] || handler.default;
};

export const favouriteResultDetailHandler = (
  type,
  {
    intrabankFavouriteResult,
    virtualAccountFavouriteResult,
    eWalletFavouriteResult,
    rtgsFavouriteResult,
    sknFavouriteResult,
    interbankFavouriteResult,
    swiftFavouriteResult,
  }
) => {
  const handler = {
    [SKN_TRANSFER]: sknFavouriteResult,
    [RTGS_TRANSFER]: rtgsFavouriteResult,
    [SWIFT_TRANSFER]: swiftFavouriteResult,
    [E_WALLET]: eWalletFavouriteResult,
    [INTERBANK]: interbankFavouriteResult,
    [INTRABANK]: intrabankFavouriteResult,
    [VIRTUAL_ACCOUNT]: virtualAccountFavouriteResult,
    default: {},
  };
  return handler[type] || handler.default;
};

export const favouriteConfirmationDetailHandler = (
  type,
  {
    intrabankFavouriteConfirmation,
    virtualAccountFavouriteConfirmation,
    eWalletFavouriteConfirmation,
    rtgsFavouriteConfirmation,
    sknFavouriteConfirmation,
    interbankFavouriteConfirmation,
    swiftFavouriteConfirmation,
  }
) => {
  const handler = {
    [SKN_TRANSFER]: sknFavouriteConfirmation,
    [RTGS_TRANSFER]: rtgsFavouriteConfirmation,
    [SWIFT_TRANSFER]: swiftFavouriteConfirmation,
    [E_WALLET]: eWalletFavouriteConfirmation,
    [INTERBANK]: interbankFavouriteConfirmation,
    [INTRABANK]: intrabankFavouriteConfirmation,
    [VIRTUAL_ACCOUNT]: virtualAccountFavouriteConfirmation,
    default: {},
  };
  return handler[type] || handler.default;
};

export const favouriteRequestTacHandler = (type, payload) => {
  store.dispatch(putResetTransferFavTac());
  const handler = {
    [SKN_TRANSFER]: () => store.dispatch(getSknTac(payload)),
    [RTGS_TRANSFER]: () => store.dispatch(requestRtgsTac(payload)),
    [VIRTUAL_ACCOUNT]: () => store.dispatch(requestVirtualAccountTac(payload)),
    [E_WALLET]: () => store.dispatch(requestEWalletTac(payload)),
    [INTRABANK]: () => store.dispatch(requestIntrabankTac(payload)),
    [INTERBANK]: () => store.dispatch(requestInterbankTac(payload)),
    [SWIFT_TRANSFER]: () => store.dispatch(requestSwiftTAC(payload)),
    default: () => {},
  };
  return (handler[type] || handler.default)();
};

export const favouriteSubmitConfirmHandler = (type, resultPayload) => {
  const handler = {
    [SKN_TRANSFER]: () => store.dispatch(getSknResult(formatCommonFavouriteResultPayload(resultPayload))),
    [RTGS_TRANSFER]: () => store.dispatch(getRtgsResult(formatCommonFavouriteResultPayload(resultPayload))),
    [VIRTUAL_ACCOUNT]: () => store.dispatch(getVirtualAccountResult(formatCommonFavouriteResultPayload(resultPayload))),
    [E_WALLET]: () => store.dispatch(getEWalletResult(formatEWalletAddFavouriteResultPayload(resultPayload))),
    [INTRABANK]: () => store.dispatch(getIntrabankResult(formatCommonFavouriteResultPayload(resultPayload))),
    [INTERBANK]: () => store.dispatch(getInterbankResult(formatInterbankAddFavouriteResultPayload(resultPayload))),
    [SWIFT_TRANSFER]: () => store.dispatch(getSwiftResult(formatSwiftFavouriteResultPayload(resultPayload))),
    default: () => {},
  };
  return (handler[type] || handler.default)();
};

export const favouriteBeneficiaryDetailsHandler = (type, detail) => {
  const handler = {
    [SKN_TRANSFER]: getSknRtgsFavouriteBeneficiaryDetails(detail),
    [RTGS_TRANSFER]: getSknRtgsFavouriteBeneficiaryDetails(detail),
    [SWIFT_TRANSFER]: getSwiftFavouriteBeneficiaryDetails(detail),
    [E_WALLET]: getEWalletFavouriteBeneficiaryDetails(detail),
    [INTRABANK]: getIntrabankFavouriteBeneficiaryDetails(detail),
    [INTERBANK]: getInterbankFavouriteBeneficiaryDetails(detail),
    [VIRTUAL_ACCOUNT]: getVirtualAccountFavouriteBeneficiaryDetails(detail),
    default: [],
  };
  return handler[type] || handler.default;
};

export const deleteFavouriteHandler = (userId, payload) => {
  const accountNo = get(payload, 'accountNumber', '');
  const transferType = get(payload, 'transferType', '');
  const bankCode = get(payload, 'bankCodePayeeCode', '');
  const handler = {
    [SKN_TRANSFER]: () => store.dispatch(deleteSknFavourite({ userId, accountNo, bankCode })),
    [RTGS_TRANSFER]: () => store.dispatch(deleteRtgsFavourite({ userId, accountNo, bankCode })),
    [SWIFT_TRANSFER]: () => store.dispatch(deleteSwiftFavourite({ userId, accountNo, bankCode })),
    [E_WALLET]: () => store.dispatch(deleteEWalletFavourite({ userId, accountNo, payeeCode: bankCode })),
    [INTRABANK]: () => store.dispatch(deleteIntrabankFavourite({ userId, accountNo })),
    [INTERBANK]: () => store.dispatch(deleteInterbankFavourite({ userId, accountNo, bankCode })),
    [VIRTUAL_ACCOUNT]: () => store.dispatch(deleteVirtualAccountFavourite({ userId, accountNo })),
    default: () => {},
  };
  return (handler[transferType] || handler.default)();
};

export const deleteTacSubmitHandler = (type, payload) => {
  const handler = {
    [SKN_TRANSFER]: () => store.dispatch(getDeleteSknResult(getSknRtgsDeleteFavouriteResultPayload(payload))),
    [RTGS_TRANSFER]: () => store.dispatch(getDeleteRtgsResult(getSknRtgsDeleteFavouriteResultPayload(payload))),
    [SWIFT_TRANSFER]: () => store.dispatch(getDeleteSwiftResult(getSwiftCommonFavouriteResultPayload(payload))),
    [E_WALLET]: () => store.dispatch(getDeleteEWalletResult(getEWalletCommonFavouriteResultPayload(payload))),
    [INTRABANK]: () => store.dispatch(getDeleteIntrabankResult(getIntrabankDeleteFavouriteResultPayload(payload))),
    [INTERBANK]: () => store.dispatch(getDeleteInterbankResult(getInterbankDeleteFavouriteResultPayload(payload))),
    [VIRTUAL_ACCOUNT]: () => store.dispatch(getDeleteVirtualAccountResult(getVirtualAccountDeleteFavouriteResultPayload(payload))),
    default: () => {},
  };
  return (handler[type] || handler.default)();
};

export const deleteProceedHandler = (type, userId, tacBean) => {
  store.dispatch(putResetTransferFavTac());
  const handler = {
    [SKN_TRANSFER]: () => store.dispatch(requestDeleteSknTac({ userId, tacBean })),
    [RTGS_TRANSFER]: () => store.dispatch(requestDeleteRtgsTac({ userId, tacBean })),
    [SWIFT_TRANSFER]: () => store.dispatch(requestDeleteSwiftTac({ userId, tacBean })),
    [E_WALLET]: () => store.dispatch(requestDeleteEWalletTac({ userId, tacBean })),
    [INTRABANK]: () => store.dispatch(requestDeleteIntrabankTac({ userId, tacBean })),
    [INTERBANK]: () => store.dispatch(requestDeleteInterbankTac({ userId, tacBean })),
    [VIRTUAL_ACCOUNT]: () => store.dispatch(requestDeleteVirtualAccountTac({ userId, tacBean })),
    default: () => {},
  };
  return (handler[type] || handler.default)();
};
